import PreLoader from "../master/PreLoader";
import MainWrapper from "../master/MainWrapper";
import AppCustomizer from "../master/AppCustomizer";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "./AuthProvider";
import { useLocation, useNavigate } from "react-router-dom";
import { Functions } from "../../helpers/Functions";

import { Bounce, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CONFIGURACIONES from "../../util/constants";
import Loader from "../global/Loader/Loader";

const AppContent = () => {
    const redirect = useNavigate();
    const location = useLocation();
    const { checkToken, getUser, getMenu, getZonasAgencias } = useContext(AuthContext);

    const [loadPage, setLoadPage] = useState(CONFIGURACIONES.INIT.STATUS_FALSE);
    // const containerRef = useRef(null);

    const showSpinnerLoader = (time =  CONFIGURACIONES.INIT.SPINNER_DURATION) => {
        setLoadPage(CONFIGURACIONES.INIT.STATUS_TRUE);
     
        setTimeout(()=> {
            setLoadPage(CONFIGURACIONES.INIT.STATUS_FALSE);
        }, time);
    };
    // Estados para manejar las configuraciones
    const [themeSettings, setThemeSettings] = useState({
        darkTheme: false,
        collapsedSidebar: false,
        sidebarPosition: true,
        sidebarType: false,
        headerPosition: true,
        boxedLayout: false,
        logoBg: 'skin1',
        navbarBg: 'skin1',
        sidebarBg: 'skin1'
    });

    // Efecto para manejar clases del navbar
    useEffect(() => {
        const navbar = document.querySelector('.topbar .navbar');
    
        if (themeSettings.navbarBg === 'skin6') {
            navbar.classList.add('navbar-light');
            navbar.classList.remove('navbar-dark');
        } else {
            navbar.classList.remove('navbar-light');
            navbar.classList.add('navbar-dark');
        }
    }, [themeSettings.navbarBg]);

    useEffect(() => {  
        document.body.setAttribute("data-theme", "ligth");
        if (themeSettings.darkTheme) {
            document.body.setAttribute("data-theme", "dark");
        }
    }, [themeSettings.darkTheme]);


    useEffect(() => {
        console.log('checkToken', checkToken());
        
        if (location.pathname === '/view/' || location.pathname === '/view'){
            redirect('/');
        }

        if (checkToken() === false) {
            Functions().signOut(redirect, toast);
        }
    }, [checkToken])

    // Manejadores de cambios
    const handleCheckboxChange = (name, value) => {
        setThemeSettings(prev => ({
        ...prev,
        [name]: value
        }));
    };

    const handleThemeChange = (type, value) => {
        setThemeSettings(prev => ({
        ...prev,
        [type]: value
        }));
    };

    // Atributos dinámicos para el main wrapper
    const mainWrapperAttributes = {
        'data-navbarbg': themeSettings.navbarBg || 'skin1',
        'data-sidebar-position': themeSettings.sidebarPosition ? 'fixed' : 'absolute',
        'data-header-position': themeSettings.headerPosition ? 'fixed' : 'relative',
        'data-boxed-layout': themeSettings.boxedLayout ? 'boxed' : 'full',
        'data-theme': themeSettings.darkTheme?'dark':'light',
        'data-sidebartype': themeSettings.sidebarType?'full':'mini-sidebar',
        'data-layout': 'vertical'
    };

    const defineName = (name) => {
        switch (name) {
            case 'darkTheme': return 'Tema Oscuro';
            case 'sidebarType': return 'Tipo de Barra Lateral'
            case 'sidebarPosition': return 'Barra Lateral Fija'
            case 'headerPosition': return 'Encabezado Fijo'
            default: return 'Diseño en Caja';
        }
    };

    const defineBackground = (name) => {
        switch (name) {
            case 'navbar': return 'Fondo de Barra de Navegación';
            case 'logo': return 'Fondo del Logo'
            default: return 'Fondo de Barra Lateral';
        }
    };

    return (
        <>
           {loadPage && <Loader />}
           <MainWrapper mainWrapperAttributes={mainWrapperAttributes} themeSettings={themeSettings}  showSpinnerLoader={showSpinnerLoader} getDataUser={getUser()} getDataMenu={getMenu()} getDataZonasAgencias={getZonasAgencias()} />
        </>
    )
}

export default AppContent;